(() => {
  'use strict';
  if (window.mushtPreparationLoaded) return;
  window.mushtPreparationLoaded = true;

  const methods = {
    hot: {
      alt: 'A warm cacao drink in a ceramic mug, serving suggestion',
      caption: 'HOT MUSHT / SERVING SUGGESTION',
      title: 'Hot Musht',
      description: 'A warm cacao drink, finished with milk or cream if you like.',
      steps: ['Measure 1 tablespoon (6g) of Musht.', 'Whisk into 8 oz hot water.', 'Add milk or cream to taste.'],
      note: 'The blend can settle. Give it another stir as you drink.'
    },
    iced: {
      alt: 'A cacao drink swirled with milk over ice, serving suggestion',
      caption: 'ICED MUSHT / SERVING SUGGESTION',
      title: 'Iced Musht',
      description: 'Start warm so the powder mixes before the drink goes over ice.',
      steps: ['Mix Musht with warm liquid first.', 'Add cold milk and ice.', 'Stir well before drinking.'],
      note: 'General iced preparation guidance. Stir again if the blend settles.'
    },
    coffee: {
      alt: 'Coffee poured from a glass carafe into a ceramic mug of cacao, serving suggestion',
      caption: 'WITH COFFEE / SERVING SUGGESTION',
      title: 'Musht with coffee',
      description: 'Add cacao and your chosen blend’s flavor to hot coffee.',
      steps: ['Measure 1 tablespoon (6g) of Musht.', 'Whisk into hot coffee.', 'Add milk or cream to taste.'],
      note: 'The blend can settle. Give it another stir as you drink.'
    }
  };
  const hasMethod = key => Object.prototype.hasOwnProperty.call(methods, key);

  function selectMethod(root, key, focus = false, updateUrl = true) {
    if (!hasMethod(key)) return;
    const method = methods[key];
    const images = root.mushtMethodImages;
    if (!images) return;
    root.querySelectorAll('[data-method]').forEach(button => {
      const active = button.dataset.method === key;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
      if (active) {
        root.querySelector('[data-method-panel]').setAttribute('aria-labelledby', button.id);
        if (focus) button.focus();
      }
    });
    const image = root.querySelector('[data-method-image]');
    image.src = images[key];
    image.alt = method.alt;
    root.querySelector('[data-method-caption]').textContent = method.caption;
    root.querySelector('[data-method-title]').textContent = method.title;
    root.querySelector('[data-method-description]').textContent = method.description;
    root.querySelector('[data-method-note]').textContent = method.note;
    root.querySelector('[data-method-steps]').replaceChildren(...method.steps.map(step => {
      const item = document.createElement('li');
      item.textContent = step;
      return item;
    }));
    root.dataset.activeMethod = key;
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('method', key);
      window.history.replaceState(window.history.state, '', url);
    }
  }

  function initialize(root) {
    if (root.dataset.preparationReady) return;
    try {
      root.mushtMethodImages = JSON.parse(root.querySelector('[data-mf-method-images]').textContent);
    } catch (_) {
      return;
    }
    root.dataset.preparationReady = 'true';
    const keys = Object.keys(methods);
    root.querySelectorAll('[data-method]').forEach(button => {
      button.addEventListener('click', () => selectMethod(root, button.dataset.method));
      button.addEventListener('keydown', event => {
        let index = keys.indexOf(button.dataset.method);
        if (event.key === 'ArrowRight') index = (index + 1) % keys.length;
        else if (event.key === 'ArrowLeft') index = (index + keys.length - 1) % keys.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = keys.length - 1;
        else return;
        event.preventDefault();
        selectMethod(root, keys[index], true);
      });
    });
    const initialMethod = new URLSearchParams(window.location.search).get('method');
    selectMethod(root, hasMethod(initialMethod) ? initialMethod : 'hot', false, false);
  }

  function initializeAll(scope = document) {
    if (scope.matches && scope.matches('[data-mf-preparation]')) initialize(scope);
    scope.querySelectorAll('[data-mf-preparation]').forEach(initialize);
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-select-method]');
    if (!trigger || !hasMethod(trigger.dataset.selectMethod)) return;
    const root = document.querySelector('[data-mf-preparation]');
    if (root) selectMethod(root, trigger.dataset.selectMethod);
  });
  document.addEventListener('mf:method:select', event => {
    const root = document.querySelector('[data-mf-preparation]');
    if (root) selectMethod(root, event.detail && event.detail.method);
  });
  window.addEventListener('popstate', () => {
    const method = new URLSearchParams(window.location.search).get('method');
    document.querySelectorAll('[data-mf-preparation]').forEach(root => selectMethod(root, hasMethod(method) ? method : 'hot', false, false));
  });
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
})();
